import { supabase } from '../../shared/supabase/supabaseClient';
import {
  normalizeBusinessTypeListRaw,
  parseBusinessTypeList,
  type BusinessTypeCode,
  type BusinessTypeListItem,
} from '../../shell/session/domain/businessProfile';

import { isOnboardingBusinessTypesFullListEnabled } from './onboardingBusinessTypeVisibility';

export async function fetchBusinessTypes(countryCode = 'AR'): Promise<BusinessTypeListItem[]> {
  const { data, error } = await supabase.rpc('list_business_types', {
    p_country_code: countryCode,
    p_include_all: isOnboardingBusinessTypesFullListEnabled(),
  });
  if (error) throw error;
  return parseBusinessTypeList(normalizeBusinessTypeListRaw(data));
}

export async function applyOnboardingCatalogPack(packCode: string): Promise<{
  pack_code: string;
  categories_enabled: number;
  products_created: number;
}> {
  const { data, error } = await supabase.rpc('apply_onboarding_catalog_pack', {
    p_pack_code: packCode,
  });
  if (error) throw error;
  const raw = data as Record<string, unknown> | null;
  return {
    pack_code: String(raw?.pack_code ?? packCode),
    categories_enabled: Number(raw?.categories_enabled ?? 0),
    products_created: Number(raw?.products_created ?? 0),
  };
}
